import React,{memo} from 'react';
import {T} from "../../../../utils/I18n/I18n";
import './LastPrice30.scss'
import ToolTip from "../../../../components/ToolTip/ToolTip";
import {useTranslation} from "react-i18next";
import {priceNumberFormatter} from "../../../../utils/price";
import InfoIcon from "../../../../icons/InfoIcon";
const LastPrice30 = ({product}) => {
    const {t} = useTranslation();

    const hasValidPrice = product?.prices?.some(
        (price) => ['simple_clearance', 'promo_price', 'simple_promo'].includes(price.price_type)
    );

    if (!hasValidPrice) {
        return null;
    }

    return (
        <div className="lastPrice30">
            <T id="product.lowestPrice" lowestPrice={priceNumberFormatter(product?.price_last_30)}/>
            <ToolTip
                tooltipText={t('product.lastPrice30Info')}
            ><InfoIcon className={'info-icon'}/>
            </ToolTip>
        </div>
    );
};

export default LastPrice30;
